var React = require('react');

function Safeicon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.14 6.865h-.332v-1.55c0-2.867-2.275-5.263-5.12-5.314a11.515 11.515 0 00-.31 0c-2.844.051-5.12 2.447-5.12 5.314v1.55H.927c-.51 0-.927.527-.927 1.178v7.776C0 16.468.416 17 .927 17h11.212c.51 0 .927-.532.927-1.181V8.043c0-.65-.416-1.178-.927-1.178zm-4.556 5.058v2.35c0 .268-.226.496-.495.496H5.977a.502.502 0 01-.494-.497v-2.35a1.398 1.398 0 01-.413-1.005c0-.745.576-1.385 1.308-1.415.077-.003.233-.003.31 0 .733.03 1.309.67 1.309 1.415 0 .393-.152.749-.413 1.006zm2.04-5.058H3.442v-1.55c0-1.708 1.389-3.12 3.092-3.12 1.704 0 3.092 1.412 3.092 3.12v1.55z","fill":"#000"}));
}

Safeicon.defaultProps = {"width":"14","height":"17","fill":"none"};

module.exports = Safeicon;

Safeicon.default = Safeicon;
